import { PUBLIC_BASE_URL, GAME_ID, HEADERS } from '@config/game.js'
import { AUTH_SCOPE_ACCOUNT } from '@config/monetization.js'
import { collectionStore, guideStore } from '@stores'
import i18n from '@plugins/localisation.js'
import { authStore } from '@stores'
import axios from 'axios'
import {
  METRIC_COLLECTION_HEADER,
  MONETIZATION_BASE_URL,
  METRIC_GUIDE_HEADER,
  METRIC_GAME_HEADER,
} from '@config'

export function create() {
  axios.defaults.baseURL = PUBLIC_BASE_URL
  axios.defaults.headers.get['Content-Type'] =
    'application/x-www-form-urlencoded'
  axios.defaults.headers.common['Content-Type'] =
    'application/x-www-form-urlencoded'
  axios.defaults.headers.post['Content-Type'] =
    'application/x-www-form-urlencoded'
  axios.defaults.headers.delete['Content-Type'] =
    'application/x-www-form-urlencoded'
  axios.defaults.headers.common['Accept'] = 'application/json'

  return axios
}

function _setHeaders(config) {
  const { accessTokens, monAccessToken, getUserLanguage } = authStore()

  const isMonEndpoint = config.url.includes(MONETIZATION_BASE_URL)

  if (accessTokens.value[GAME_ID] && config.anonymous !== true) {
    const token = isMonEndpoint
      ? monAccessToken.value?.[AUTH_SCOPE_ACCOUNT]?.monetization_bearer
      : accessTokens.value[GAME_ID]
    config.headers.Authorization = `Bearer ${token}`
  }

  config.headers['Accept-Language'] =
    i18n.global.locale.value || getUserLanguage()

  if (HEADERS.portal) {
    config.headers['X-Modio-Portal'] = HEADERS.portal
  }
  if (HEADERS.platform) {
    config.headers['X-Modio-Platform'] = HEADERS.platform
  }

  if (config.external !== true) {
    config.headers['X-Modio-Origin'] = 'web'
  }

  return config
}

function _handleMetricsIds(config) {
  if (config.metrics?.enabled !== true) {
    return config
  }
  const { getGuideId } = guideStore()
  const { getCollectionId } = collectionStore()

  if (config.metrics.guideNameId) {
    config.headers[METRIC_GAME_HEADER] = GAME_ID
    config.headers[METRIC_GUIDE_HEADER] = getGuideId(
      config.metrics.guideNameId,
      GAME_ID
    )
  }

  if (config.metrics.collectionNameId) {
    config.headers[METRIC_GAME_HEADER] = GAME_ID
    config.headers[METRIC_COLLECTION_HEADER] =
      config.metrics.collectionId ??
      getCollectionId(config.metrics.collectionNameId, GAME_ID)
  }

  return config
}

axios.interceptors.request.use(function (config) {
  config = _handleMetricsIds(config)
  config = _setHeaders(config)

  return config
})
